const importImage = (fileName) => {
    return require(`./images/${fileName}`);
  };
  
  export const importIcons = (fileName) => {
    return require(`./icons/${fileName}`);
  };
  
  
  export const Images = {
    colorBar : importImage("colour-Bar.png"),
    gif : importImage("login.gif"),
    forgotPasswordImg : importImage("forgotPassword.svg"),
    successGif : importImage("success.gif"),
    profileBanner : importImage("profileBanner.png"),
    profile : importImage("profile.png"),
    pdfFormat : importImage("pdfFormat.png"),
    docFormat : importImage("docFormat.png"),
    appleStore : importImage("apple-en.png"),
    googleStore : importImage("google-en.png"),
    excelFomrat : importImage('sheets.png'),

    //contact form
    imageFormat : importImage("imageFormat.png"),
    videoFormat : importImage("videoFormat.png"),
    mailReceive : importImage('mail-receive.svg'),
    mailResolved : importImage('mail-resolved.svg'),
    mailPending : importImage('mail-pending.svg'),
    actionCircle : importImage('action-circle.png'),

    // Qr code
    breakLine : importImage('breakLine.svg'),

    // Catalog Images
    catalogImg : importImage('catalog.svg'),

    //no image
    noImage : importImage('no-image.png'),
  }

  export const Icons = {
    kgLogo : importIcons("kglogo.svg"),
    bellIcon : importIcons("bell.svg"),
    warning : importIcons("warning.svg"),
    edit : importIcons("edit.svg"),
    delete : importIcons("delete.svg"),
    eye : importIcons("eye.svg"),
    search : importIcons("search.svg"),
    filter : importIcons("filter.svg"),
    checked : importIcons("checked.svg"),
    addIcon : importIcons("add.svg"),
    uploadIcon : importIcons("uploadIcon.svg"),
    downloadIcon : importIcons("downloadIcon.svg"),
    uploadSecondary : importIcons("uploadSecondaryIcon.svg"),
    searchIcon : importIcons("search.svg"),
    filterIcon : importIcons('filter.svg'),
    previousIcon : importIcons('previous.svg'),
    nextIcon : importIcons('next.svg'),
    dropdown : importIcons('chevron-down.svg'),
    uploadIcon : importIcons('upload.png'),
    closeCircle : importIcons('close-circle.svg'),
    tickIcon : importIcons('tick.svg'),
    changeIcon : importIcons('refresh.png'),

    // DASHBOARD ICONS
    totalUser : importIcons("totalUsers.svg"),
    totalQR : importIcons("totalQR.svg"),
    totalProducts : importIcons("totalProducts.svg"),
    totalFeedback : importIcons("totalFeedback.svg"),
    totalInCompleteRetailers : importIcons("TotalIncompleteRetailers.png"),
    openRedeemRewards : importIcons("OpenRedeemRewards.png"),
    totalIncompleteMechanics : importIcons("TotalIncompleteMechanics.png"),
    totalOpenContactForms : importIcons("TotalOpenContactForms.png"),
    totalOpenEnquiries : importIcons("TotalOpenEnquiries.png"),
    totalRetailerVerifiedWithoutTarget : importIcons("TotalRetailerVerifiedWithoutTarget.png"),
    

    // SIDEBAR ICONS
    dashboard : importIcons("dashboard.svg"),
    userIcon : importIcons("users.svg"),
    manageAdmins : importIcons("manageAdmins.svg"),
    productCatalog : importIcons("productCatalog.svg"),
    resources : importIcons("resources.svg"),
    star : importIcons("star.svg"),
    rewards : importIcons("rewards.svg"),
    feedback : importIcons("feedback.svg"),
    enquiry : importIcons("enquiry.svg"),
    contactLog : importIcons("contactLog.svg"),
    content : importIcons("content.svg"),
    notification : importIcons("notification.svg"),
    qrCode : importIcons("qrCode.svg"),
    report : importIcons("report.svg"),
    addpoints : importIcons("addpoints.svg"),
    logout : importIcons("logout.svg"),
    fileText : importIcons("file-text.svg"),

    //Contact form
    sendIcon : importIcons('send.svg'),
    closeIcon : importIcons('x-circle.svg'),

    // QR code
    qrIcon : importIcons('qrImg.svg') ,
    redCircle : importIcons('redCircle.svg'),

  }
  